

class Menu {

    constructor() {
        if(window.jQuery){
            jQuery(".dropdown-menu").click(function (event) {
              event.stopPropagation();
            });
        }
    }

}

export default Menu;